import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { tap, map, catchError } from 'rxjs/operators';
import { CaseTypeRepository } from '../../../infrastructure/repositories/case-type.repository';
import { CaseTypeState } from '../../states/case-type.state';
import { GetCaseTypeCategoriesResult } from './get-case-type-categories.result';

@Injectable({ providedIn: 'root' })
export class GetCaseTypeCategoriesUseCase {
  private readonly repository = inject(CaseTypeRepository);
  private readonly state = inject(CaseTypeState);

  public execute(): Observable<GetCaseTypeCategoriesResult> {
    this.state.setLoadingCategories(true);
    this.state.setErrorCategories(null);
    return this.repository.getCategories().pipe(
      tap((categories) => {
        this.state.setCategories(categories);
        this.state.setLoadingCategories(false);
      }),
      map((categories) => ({ categories })),
      catchError((error) => {
        this.state.setErrorCategories(error?.error?.message || error?.message || 'Failed to load categories');
        throw error;
      })
    );
  }
}
